// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1BsLe","noInteraction":"EventWrapper_noInteraction__16kom","pointerPassthrough":"EventWrapper_pointerPassthrough__33UmL"};